document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('#SiteNav');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      nav.classList.toggle('is-open', !open);
    });
  }
  document.querySelectorAll('[data-product-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const price = option.dataset.price;
      const available = option.dataset.available === 'true';
      const form = select.closest('form');
      const button = form && form.querySelector('[data-add-button]');
      const priceEl = document.querySelector('[data-product-price]');
      if (priceEl && price) priceEl.textContent = price;
      if (button) {
        button.disabled = !available;
        button.textContent = available ? button.dataset.addText : button.dataset.soldText;
      }
    });
  });
});
